import { plural, t } from '@lingui/core/macro';
import { Button, Menu } from '@pocketlaw/tetris';
import { useFileBrowserContext } from 'app/domains/filesystem';
import { SelectedEntry } from './SelectedEntry';
export function SelectedEntries() {
    const { selected } = useFileBrowserContext();
    const count = selected.length;
    const label = t({
        context: 'entry-picker',
        comment: 'File browser: Selected files chip',
        message: plural(count, {
            0: 'No files selected',
            one: '# selected file',
            other: '# selected files',
        }),
    });
    return (<Menu.Root target={<Button type="button" size="small" appearance="ghost" disabled={!selected.length}>
          {label}
        </Button>}>
      <Menu.Header title={t({ message: 'Selected files', comment: 'File browser: Selected files menu header' })}/>
      {selected.map((entry) => (<SelectedEntry key={entry.id} entry={entry}/>))}
    </Menu.Root>);
}
